/* eslint-disable @typescript-eslint/naming-convention */
import React from 'react';
import { Text } from '../../../../../../ui/atoms/Text/Text';
import { AGENT_LIST } from '../../../../constants/agents';
import { PromptSuggestions } from '../PromptSuggestions';
import './EmptyViewStyles.scss';
const BASE_CLASS = 'ai-chat-empty-view';
export function EmptyView({ userName, agents: _agents = AGENT_LIST, onSelectAgent: _onSelectAgent, onSelectPrompt, promptSuggestions, promptSuggestionsLabel, onChipSelect }) {
    const greeting = userName ? `Hi ${userName}, how can I help?` : 'How can I help you today?';
    return (React.createElement("div", { className: BASE_CLASS },
        React.createElement("div", { className: `${BASE_CLASS}__header` },
            React.createElement("i", { className: `${BASE_CLASS}__flame fa-kit fa-inspectpoint-flame` }),
            React.createElement(Text, { variant: "large", as: "h2", className: `${BASE_CLASS}__greeting` }, greeting),
            React.createElement(Text, { variant: "body", as: "p", className: `${BASE_CLASS}__subtitle` }, "Ask me anything about your buildings, inspections, or equipment")),
        React.createElement("div", { className: `${BASE_CLASS}__suggestions` },
            React.createElement(PromptSuggestions, { onSelectPrompt: onSelectPrompt, suggestions: promptSuggestions, groupLabel: promptSuggestionsLabel, onChipSelect: onChipSelect }))));
}
